import { Routes, Route, useParams, useNavigate } from 'react-router-dom';

import { AddEdit } from '.';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { userActions } from '_store';
import { ReturnButton } from '_components/buttons';
export { UserLayout };

function UserLayout() {
    
    const auth = useSelector(x => x.auth.value);
    const user = useSelector(x => x.users?.item)
    const {username} = useParams()
    let navigate = useNavigate();
    const dispatch = useDispatch();

    /** Redirect if user changes manually url parameters */
    useEffect(() => {
        if (username === auth.username && !user){
            const {access_token, token_type, ...user} = auth
            dispatch(userActions.setUser(user))
        }
        if (!username || !auth.username) 
            navigate("/");
        if (auth?.username !== username){
            let url = `/user/${auth.username}`;            
            navigate(url);
        }
    }, [username])

    return (
        <div className="pt-16">
            <div className="container">
                <div className="ml-10 pl-12">
                    <ReturnButton />
                </div>                
                <Routes>
                    {auth?.username === username && <Route index element={<AddEdit />} />}
                </Routes>
            </div>
        </div>
    );
}
